import React from 'react';
import { Flex } from 'components';
import { AttachmentsLabel, LinkedAttachmentName } from './styledComponents';

const LinkedAttachments = ({ linkedAttachments = [] }) => {
  if (!linkedAttachments.length) {
    return null;
  }

  return (
    <Flex>
      <AttachmentsLabel>Attachments: </AttachmentsLabel>
      {linkedAttachments.map((attachment, index) => (
        <React.Fragment key={attachment.url}>
          <LinkedAttachmentName
            href={attachment.url}
            title={attachment.name}
            target="_blank"
          >
            {attachment.name}
          </LinkedAttachmentName>
          {index + 1 < linkedAttachments.length ? <span>,&nbsp;</span> : null}
        </React.Fragment>
      ))}
    </Flex>
  );
};

export default LinkedAttachments;
